import radium from 'radium';
import history from '../../lib/history';

import Button from '../../components/button/Button.tsx';

function EventPageSeatingplanBtn(props) {
	function openEventPageSeatingplan() {
		const eventPageUrl = `sp/${props.eventUUID}`;
		history.push(eventPageUrl);
	}

	const style = {
		width: '100%',
		height: '100%',
	};

	return (
		<Button
			buttonContainerStyle={style}
			name="eventPageSeatingplan"
			buttonText="Zurück"
			onClick={openEventPageSeatingplan}
		/>
	);
}

export default radium(EventPageSeatingplanBtn);
